import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

@Injectable({
  providedIn: 'root',
})
export class BlacklistService {
  constructor(private restangular: ApiClient) {}

  create(data: any): Promise<any> {
    return this.restangular.one('admin').one('blacklist').customPOST(data).toPromise();
  }

  list(): Promise<any[]> {
    return this.restangular.one('admin').one('blacklist').getList().toPromise();
  }

  remove(resourceType: string, resourceId: string): Promise<any> {
    return this.restangular
      .one('admin')
      .one('blacklist')
      .one('resourceType', resourceType)
      .one('resourceId', resourceId)
      .customDELETE()
      .toPromise();
  }
}
